import { Rule, RuleObject } from 'antd/lib/form'
import { StoreValue } from 'antd/lib/form/interface'
import moment, { Moment } from 'moment'
import React from 'react'
// import {
//   formatTimeRange,
//   reasonForBookingLabel,
// } from '../../pages/EAP/EAP-constants'
// import { AppointmentType } from '../../pages/EAP/appointment-page/appointment-page-middleware'
// import { ContactTypesInterface } from '../metadata/metadata-middleware'
// import { FiltersInterface } from '../../pages/EAP/appointment-page/interfaces/available-slots-request-interface'
// import { FilterTypes } from '../utils/mixpanel-constants'

export const FormRequiredMessage = (
  elementName: string | React.ReactNode
): JSX.Element => {
  if (typeof elementName === 'string') {
    return (
      <span className="break-words block whitespace-normal text-[13px] w-66 pt-[0.25rem] pb-[0.5rem]">
        {
          `${elementName
            ?.replace('Create', '')
            ?.replace('Confirm', '')
            ?.replace("Household member's", '')
            ?.replace("Employee's", '')
            ?.replace('(MM/DD/YYYY or MM-DD-YYYY)', '')} is missing`
          //The name of field label should be different to the label in the error message, added this extra condition for 'purpose of booking appointment' field
          //?.replace(reasonForBookingLabel, 'Purpose of visit')
        }
      </span>
    )
  }
  return (
    <span className="break-words block whitespace-normal text-[13px] w-66 pt-[0.25rem] pb-[0.5rem]">{`${elementName} is missing`}</span>
  )
}
export const FormInvalidMessage = (
  elementName: string | React.ReactNode | any,
  message?: string
) => {
  if (message && typeof message === 'string') {
    return `${
      elementName?.replace('Create', '')
      //The name of field label should be different to the label in the error message, added this extra condition for 'purpose of booking appointment' field
      //?.replace(reasonForBookingLabel, 'Purpose of visit')
    } ${message}
      `
  }
  return `${elementName} is invalid`
}
export declare type Validator = (
  rule: RuleObject,
  value: StoreValue,
  callback: (error?: string) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => Promise<void | any> | void

export const formRules = (
  label: string | React.ReactNode,
  required?: boolean,
  validator?: Validator,
  pattern?: RegExp,
  patternMessage?: string,
  min?: {
    value: number
    message: string
  },
  max?: {
    value: number
    message: string
  },
  isURL?: boolean,
  isEmail?: boolean,
  isOTP?: boolean
): Rule[] => {
  const rules: Rule[] = []
  if (required) {
    rules.push({ required: required, message: FormRequiredMessage(label) })
  }
  if (validator) {
    rules.push({ validator: validator })
  }
  if (pattern) {
    rules.push({ pattern: pattern, message: patternMessage })
  }
  if (min) {
    rules.push({
      min: min.value,
      message: FormInvalidMessage(label, min.message),
    })
  }
  if (max) {
    rules.push({ max: max.value, message: FormInvalidMessage(label) })
  }
  if (isURL) {
    rules.push({ type: 'url', message: FormInvalidMessage(label) })
  }
  if (isEmail) {
    rules.push({
      type: 'email',
      message: FormInvalidMessage(label),
    })
  }
  if (isOTP) {
    rules.push({ message: FormInvalidMessage(label) })
  }
  return rules
}
export const disabledDate = (current: Moment) => {
  return (
    (current && current > moment(new Date())) ||
    current < moment('01/01/1800', 'MM/DD/YYYY')
  )
}

export const hasLowerCase = (str: string) => {
  return str.toUpperCase() != str
}

export const hasUpperCase = (str: string) => {
  return str.toLowerCase() != str
}

export const hasDigit = (str: string) => {
  const hasNumber = /\d/
  return hasNumber.test(str)
}

export const hasSymbol = (str: string) => {
  return str.match(/\W/)
}

export const getTypeOfAppointment = (
  appointmentType: AppointmentType,
  contactTypeIdList: ContactTypesInterface[]
) => {
  return appointmentType === AppointmentType.PHONE_CALL
    ? contactTypeIdList.find((e) => e.name === 'Phone Call')?.id
    : contactTypeIdList.find((e) => e.name === 'Healthie Video Call')?.id
}

interface FilterRequestInterface {
  StartTime?: string
  EndTime?: string
  WeekDays?: number[]
  specializations?: string[]
}

export const getAppliedFilters: (
  selectedDaysArray?: boolean[],
  range?: [number, number],
  selectedSpecialisationItems?: string[]
) => FilterRequestInterface = (
  selectedDaysArray?,
  range?,
  selectedSpecialisationItems?
) => {
  let Filters: FilterRequestInterface = {}
  if (selectedDaysArray) {
    if (
      !(
        selectedDaysArray?.every((value) => value === false) ||
        selectedDaysArray?.every((value) => value === true)
      )
    ) {
      Filters = {
        ...Filters,
        WeekDays: selectedDaysArray
          ?.map((isSelected: boolean, index: number) =>
            isSelected ? index : -1
          )
          .filter((weekday) => weekday != -1),
      }
    }
  }
  if (range) {
    const [startTime, endTime] = formatTimeRange(range)
    if (!range?.every((value, index) => value === [420, 1260][index])) {
      Filters = {
        ...Filters,
        StartTime: startTime,
        EndTime: endTime,
      }
    }
  }
  if (selectedSpecialisationItems && selectedSpecialisationItems.length > 0) {
    Filters.specializations = selectedSpecialisationItems
  }

  return Filters
}

export const getEncodedSearchQuery = (searchQuery: string) => {
  if (searchQuery != '') {
    return encodeURIComponent(searchQuery)
  }
  return null
}

export function getAppliedFiltersFromObject(
  filter: FiltersInterface
): FilterTypes {
  const { language, WeekDays, StartTime, EndTime } = filter

  const hasLanguage = Boolean(language != 'English')
  const hasDays = Array.isArray(WeekDays) && WeekDays.length > 0
  const hasTime = Boolean(StartTime && EndTime)

  if (hasLanguage && hasDays && hasTime) {
    return FilterTypes.DAYS_TIME_LANGUAGE
  }

  if (hasLanguage && hasDays) {
    return FilterTypes.DAYS_AND_LANGUAGE
  }

  if (hasDays && hasTime) {
    return FilterTypes.DAYS_AND_TIME
  }

  if (hasTime && hasLanguage) {
    return FilterTypes.TIME_AND_LANGUAGE
  }

  if (hasDays) {
    return FilterTypes.DAYS_OF_THE_WEEK
  }

  if (hasTime) {
    return FilterTypes.TIME_RANGE
  }

  if (hasLanguage) {
    return FilterTypes.LANGUAGE
  }

  return FilterTypes.NONE
}

export function removeHighlightedTagStrings(
  a: string[],
  b: string[]
): string[] {
  // Use the filter function to return an array that only includes items not present in 'a'
  const result = b.filter((item) => !a.includes(item))
  return result
}

export function removeEmTags(array: string[]): string[] {
  return array.map((item) => item.replace(/<\/?em>/g, ''))
}
